import { getCookie, delCookie, setCookie } from '../plugins/cookie'
import { reactive } from 'vue'
import { ElMessage } from "element-plus"

const COOKIE_DOMAIN = process.env.NODE_ENV === 'production' ? 'ceping.cheyun.com' : 'localhost'
const COOKIE_KEYS = ['avatar', 'loginToken', 'nickName', 'username', 'mobile', 'failure_date', 'role_id', 'permission']

function createCompareStore(stateKey, storageSuffix) {
    return {
        get() {
            const raw = localStorage.getItem(getCookie('loginToken') + storageSuffix)
            this.state[stateKey] = raw ? JSON.parse(raw) : []
            return this.state[stateKey]
        },
        set(car) {
            let data = this.state[stateKey] || this.get() || []
            data = data || []
            if (data.some(item => item.model_id === car.model_id)) {
                ElMessage.error('该车型已加入对比!')
                return
            }
            if (data.length >= 3) {
                ElMessage.error('只能对比3款车型!')
                return
            }
            data.push(car)
            localStorage.setItem(getCookie('loginToken') + storageSuffix, JSON.stringify(data))
            this.state[stateKey] = data
            ElMessage.success('加入成功!')
        },
        update(old_id, new_car) {
            let data = this.state[stateKey] || this.get() || []
            for (let [index, item] of data.entries()) {
                if (item.model_id === old_id) {
                    data.splice(index, 1, new_car)
                    localStorage.setItem(getCookie('loginToken') + storageSuffix, JSON.stringify(data))
                    ElMessage.success('已更换该对比车型!')
                    this.state[stateKey] = JSON.parse(localStorage.getItem(getCookie('loginToken') + storageSuffix))
                    break
                }
            }
        },
        delete(model_id) {
            let data = this.state[stateKey] || this.get() || []
            for (let [index, item] of data.entries()) {
                if (item.model_id === model_id) {
                    data.splice(index, 1)
                    localStorage.setItem(getCookie('loginToken') + storageSuffix, JSON.stringify(data))
                    ElMessage.success('已删除该对比车型!')
                    this.state[stateKey] = JSON.parse(localStorage.getItem(getCookie('loginToken') + storageSuffix))
                    break
                }
            }
        },
        clear() {
            localStorage.setItem(getCookie('loginToken') + storageSuffix, JSON.stringify([]))
            this.state[stateKey] = []
        },
    }
}

const compareStores = {
    compareCar:     createCompareStore('compareCarData',         'compareCar'),
    compareCar2:    createCompareStore('compareCarData2',        'compareCar2'),
    compareCarV2:   createCompareStore('compareCarDataV2',       'compareCarV2'),
    compareDrive:   createCompareStore('compareCarData_drive',   'compareCar_drive'),
    compareDrive2:  createCompareStore('compareCarData2_drive',  'compareCar2_drive'),
    compareV2Drive: createCompareStore('compareCarDataV2_drive', 'compareCarV2_drive'),
    compareOta:      createCompareStore('compareCarDataOta',       'compareCarOta'),
    compareBrandOta: createCompareStore('compareBrandDataOta',     'compareBrandOta'),
}

const store = {
    debug: true,
    state: reactive({
        userInfo: null,
        isLogin: false,
        has_review_hide: 0,
        has_intelligent_hide: 0,
        download_content: 0,
        compareCarData: null,
        compareCarData2: null,
        compareCarDataV2: null,
        compareCarData_drive: null,
        compareCarData2_drive: null,
        compareCarDataV2_drive: null,
        compareCarDataOta: [],
        compareBrandDataOta: [],
        downloadList: [],
        addDownList: [],
    }),

    getFilenameFromUrl(url) {
        const parts = url.split('.')
        return parts[parts.length - 1]
    },

    addDownload(url_list, model_name, node_name) {
        const that = this
        that.state.addDownList = url_list.map((item, ind) => {
            return {
                id: item.attach_id,
                name: model_name + '-' + node_name + '-' + ind + '.' + that.getFilenameFromUrl(item.attach_value),
                url: item.attach_value.replace('http://', 'https://'),
                progress: 0,
                xhr: null,
            }
        })
    },

    signOut() {
        COOKIE_KEYS.forEach(key => delCookie(key, COOKIE_DOMAIN))
        this.state.userInfo = null
        this.state.isLogin = false
    },

    signIn(userInfo, type) {
        COOKIE_KEYS.forEach(key => {
            if (userInfo[key] !== undefined) {
                setCookie(key, userInfo[key], COOKIE_DOMAIN, 999 * 24 * 60 * 60)
            }
        })
        setCookie('sign_methods', type || 1, COOKIE_DOMAIN, 999 * 24 * 60 * 60)
        this.state.userInfo = userInfo
        this.state.isLogin = true
    },

    updateCookie(key, value) {
        setCookie(key, value, COOKIE_DOMAIN, 999 * 24 * 60 * 60)
    },

    updateUsername(username) {
        this.state.userInfo = { ...this.state.userInfo, username }
    },

    checkLogin() {
        let userInfo = null
        const loginToken = getCookie('loginToken')
        if (loginToken) {
            userInfo = {
                loginToken,
                avatar: getCookie('avatar'),
                nickName: getCookie('nickName'),
                username: getCookie('username'),
                role: getCookie('role_id') || 0,
                permission: getCookie('permission') || '',
            }
        }
        this.state.userInfo = userInfo
        return userInfo
    },

    checkLeafHide(type, num) {
        if (type === 'zc') { this.state.has_review_hide = num }
        if (type === 'js') { this.state.has_intelligent_hide = num }
    },

    // compareCarData（座舱 v1 主对比）
    getCompareCarData()              { return compareStores.compareCar.get.call(this) },
    setCompareCarData(car)           { compareStores.compareCar.set.call(this, car) },
    deleteCompareCarData(model_id)   { compareStores.compareCar.delete.call(this, model_id) },

    // compareCarData2（座舱 v1 首页对比）
    getCompareCarData2()                        { return compareStores.compareCar2.get.call(this) },
    setCompareCarData2(car)                     { compareStores.compareCar2.set.call(this, car) },
    updateCompareCarData2(old_id, new_car)      { compareStores.compareCar2.update.call(this, old_id, new_car) },
    deleteCompareCarData2(model_id)             { compareStores.compareCar2.delete.call(this, model_id) },
    clearCompareCarData2()                      { compareStores.compareCar2.clear.call(this) },

    // compareCarDataV2（座舱 v2）
    getCompareCarDataV2()                       { return compareStores.compareCarV2.get.call(this) },
    setCompareCarDataV2(car)                    { compareStores.compareCarV2.set.call(this, car) },
    updateCompareCarDataV2(old_id, new_car)     { compareStores.compareCarV2.update.call(this, old_id, new_car) },
    deleteCompareCarDataV2(model_id)            { compareStores.compareCarV2.delete.call(this, model_id) },
    clearCompareCarDataV2()                     { compareStores.compareCarV2.clear.call(this) },

    // compareCarData_drive（驾驶主对比）
    getCompareCarData_drive()                   { return compareStores.compareDrive.get.call(this) },
    setCompareCarData_drive(car)                { compareStores.compareDrive.set.call(this, car) },
    deleteCompareCarData_drive(model_id)        { compareStores.compareDrive.delete.call(this, model_id) },

    // compareCarData2_drive（驾驶首页对比）
    getCompareCarData2_drive()                  { return compareStores.compareDrive2.get.call(this) },
    setCompareCarData2_drive(car)               { compareStores.compareDrive2.set.call(this, car) },
    updateCompareCarData2_drive(old_id, new_car){ compareStores.compareDrive2.update.call(this, old_id, new_car) },
    deleteCompareCarData2_drive(model_id)       { compareStores.compareDrive2.delete.call(this, model_id) },
    clearCompareCarData2_drive()                { compareStores.compareDrive2.clear.call(this) },

    // compareCarDataV2_drive（驾驶 v2）
    getCompareCarDataV2_drive()                 { return compareStores.compareV2Drive.get.call(this) },
    setCompareCarDataV2_drive(car)              { compareStores.compareV2Drive.set.call(this, car) },
    updateCompareCarDataV2_drive(old_id, new_car){ compareStores.compareV2Drive.update.call(this, old_id, new_car) },
    deleteCompareCarDataV2_drive(model_id)      { compareStores.compareV2Drive.delete.call(this, model_id) },
    clearCompareCarDataV2_drive()               { compareStores.compareV2Drive.clear.call(this) },

    // compareCarDataOta（OTA 对比）
    getCompareCarDataOta()              { return compareStores.compareOta.get.call(this) },
    setCompareCarDataOta(car)           { compareStores.compareOta.set.call(this, car) },
    deleteCompareCarDataOta(model_id)   { compareStores.compareOta.delete.call(this, model_id) },

    // compareBrandDataOta（OTA 品牌对比）
    getCompareBrandDataOta()            { return compareStores.compareBrandOta.get.call(this) },
    setCompareBrandDataOta(car)         { compareStores.compareBrandOta.set.call(this, car) },
    deleteCompareBrandDataOta(model_id) { compareStores.compareBrandOta.delete.call(this, model_id) },

    getDownloadAuth(route) { // eslint-disable-line no-unused-vars
        return this.state.download_content === 1
    },
}

export default store
